import { Grid } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import NavMotion from 'layout/NavMotion';
import AppBar from 'ui-component/extended/AppBar';
import Footer from 'views/landing/Footer';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => {
    const location = useLocation();

    return (
        <>
            {location.pathname !== '/login' && location.pathname !== '/register' && location.pathname !== '/forgot' ? (
                <Grid container>
                    <Grid item xs={12}>
                        <AppBar />
                    </Grid>
                    <Grid item xs={12} sx={{ p: 1.5, backgroundColor: '#D4D7E6', mt: { xs: 6.75, sm: 6.375 } }}>
                        <NavMotion>
                            <Outlet />
                        </NavMotion>
                    </Grid>
                    <Footer />
                </Grid>
            ) : (
                <Outlet />
            )}
        </>
    );
};

export default MinimalLayout;
